export const API_BASE_URL = "https://prod-api.my-record.net";
export const API_IMG_URL = "https://myrecord-images.s3.amazonaws.com";
export const GOOGLE_MAP_API_KEY = "AIzaSyB6DQZf49qirS6Kshj3ewpIuTcgXRenLTY";
